import {
  QUOTATION_ALL,
  QUOTATION_GET,
  QUOTATION_PUT,
  QUOTATION_DEL,
  QUOTATION_POST,
} from "../../actions/types";

const initialState = {
  quotation: null,
  isLoading: false,
};
export default function (state = initialState, action) {
  switch (action.type) {
    case QUOTATION_ALL:
      return {
        arr: [...action.payload],
        isLoading: true,
      };
    case QUOTATION_GET:
      return {
        ...action.payload,
        isLoading: true,
      };
    case QUOTATION_POST:
      return action.payload;
    case QUOTATION_PUT:
      return action.payload;
    case QUOTATION_DEL:
      return { isLoading: true };
    default:
      return state;
  }
}
